export class PosicaoIcone {

    static analiseColor (ign, color) {
        if(ign === 'ON') {
            return 'verde';
        } else {
            if (color === 'red') {
                return 'vermelho';
            }
            return 'cinza';
        }
    }

    static getPlaca (placa, ign) {
        return (ign === 'ON') ? '<span style=\'color:GREEN\'><b>' + placa + '</b><span>' : '<span style=\'color:GRAY\'><b>' + placa + '</b><span>';
    }

    static createIcon (pos) {
        return L.icon({
            iconUrl: '/assets/img/icons/' + PosicaoIcone.analiseColor(pos.ignition, pos.color_icon) + '/' + (pos.tipo || 'car') + '.png',
            iconSize: [33, 40],
            iconAnchor:   [17, 42],
            popupAnchor: [1, -32],
            shadowAnchor: [10, 12],
            shadowSize: [36, 16]
        });
    }
}
